var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{class:_vm.classModifiers,attrs:{"href":_vm.link,"target":_vm.target},on:{"click":_vm.onClick}},[_c('div',{class:_vm.iconClassModifiers}),_c('div',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }